<template>
  <div>
    <v-toolbar dark color="deep-purple">
      <v-btn icon class="hidden-xs-only" @click="back()">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-toolbar-title class="white--text">รายการกลุ่มใหญ่</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title class="subheading white--text">วิชา {{ activeCourse.subject.label }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title class="subheading white--text">ปีการศึกษาที่ {{ activeCourse.academicYear.semesterYear }}</v-toolbar-title>
    </v-toolbar>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="pagination.q"
          append-icon="search"
          label="ค้นหา"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-tooltip left v-if="allowedRoles">
          <v-btn color="deep-purple" slot="activator" dark fab @click="addItem()">
            <v-icon>playlist_add</v-icon>
          </v-btn>
          <span>เพิ่มกลุ่มใหญ่</span>
        </v-tooltip>
      </v-card-title>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="items"
        :total-items="pagination.totalItems"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.code }}</td>
          <td class="text-xs-left">{{ props.item.name }}</td>
          <td class="text-xs-left">{{ props.item.day }}</td>
          <td class="text-xs-left">{{ props.item.startTime }}</td>
          <td class="text-xs-left">{{ props.item.endTime }}</td>
          <td class="text-xs-left">{{ props.item.hours }}</td>
          <td class="text-xs-left">{{ props.item.room.name }}</td>
          <td class="text-xs-left">{{ props.item.totalStudent }}</td>
          <td class="justify-center layout px-0">
            <v-layout row>
              <v-tooltip left>
                <v-btn icon class="mx-2" slot="activator" @click="viewItem(props.item)">
                  <v-icon color="deep-purple ">pageview</v-icon>
                </v-btn>
                <span>ดูข้อมูลกลุ่ม {{ props.item.code }}</span>
              </v-tooltip>
              <v-tooltip left v-if="allowedRoles">
                <v-btn icon class="mx-0" slot="activator" @click="deleteItem(props.item)">
                  <v-icon color="red">delete</v-icon>
                </v-btn>
                <span>ลบ {{ props.item.code }}</span>
              </v-tooltip>
            </v-layout>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ pagination.q }}" found no results.
        </v-alert>
      </v-data-table>

      <div class="text-xs-center pt-2">
        <v-pagination v-model="pagination.page" :length="pages" :total-visible="7"></v-pagination>
      </div>

      <component :is="formDialog" :dialog="dialog" :action="action" :title="title" :activeCourseId="activeCourseId" :item="selectedItem" @dialog="dialog = $event"></component>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import swal from 'sweetalert2'
import SectionFormDialog from './formDialog.vue'

export default {
  props:['activeCourseId', 'allowedRoles'],
  components: {
    SectionFormDialog
  },
  data () {
    return {
      action: null,
      dialog: false,
      title: {
        icon: null,
        text: null
      },
      formDialog: null,
      loading: false,
      headers: [
        { text: 'รหัสกลุ่ม', align: 'left', sortable: true, value: 'code' },
        { text: 'ชื่อกลุ่ม', align: 'left', sortable: true, value: 'name' },
        { text: 'วันที่สอน', align: 'left', sortable: true, value: 'day' },
        { text: 'เวลาเริ่มต้น', align: 'left', sortable: true, value: 'startTime' },
        { text: 'เวลาสิ้นสุด', align: 'left', sortable: true, value: 'endTime' },
        { text: 'จำนวน ชม.', align: 'left', sortable: true, value: 'hours' },
        { text: 'ห้อง', align: 'left', sortable: true, value: 'room.name' },
        { text: 'จำนวน น.ศ.', align: 'left', sortable: true, value: 'totalStudent' },
        { sortable: false }
      ],
      pagination: {
        q: '',
        sortBy: 'code',
        page: 1,
        rowsPerPage: 10,
        descending: true,
        totalItems: 0,
        activeCourseId: this.activeCourseId
      },
      items: [],
      selectedItem: {}
    }
  },
  mounted () {
    this.reload()
  },
  updated () {
    // console.log('updated')
  },
  computed: {
    ...mapGetters({
      activeCourse: 'activeCourse/activeCourse'
    }),
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      ) return 0

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    }
  },
  methods: {
    addItem () {
      this.reset()
      this.title.icon = 'add'
      this.title.text = 'เพิ่มรายการ'
      this.formDialog = 'section-form-dialog'
      setTimeout(()=>{this.dialog = true}, 300)
    },
    back () {
      // this.$router.go(-1)
      this.$router.push({ name: 'activeCourse', params: { academicYearId: this.activeCourse.academicYear.id } })
    },
    deleteItem (item) {
      swal({
        title: 'คุณแน่ใจ?',
        text: "คุณจะไม่สามารถเรียกคืนข้อมูลได้อีก!",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่, ฉันต้องการลบข้อมูลนี้!'
      }).then((result) => {
        console.log('swal', result.value)
        if (result.value) {
          this.$store.dispatch('section/delete', item)
            .then((response) => {
                console.log('reload:', response )
                this.reload()
              }).catch((error) => {
                swal('Error!', error.message, 'error')
              })
          swal(
            'ลบรายการ!',
            'คุณได้ทำการลบรายการเรียบร้อยแล้ว',
            'success'
          )
        }
      })
    },
    viewItem (item) {
      this.$store.dispatch('section/setSection', item)
      this.$router.push({ name: 'sectionShow', params: { sectionId: item.id, allowedRoles: this.allowedRoles}})
    },
    reload () {
      this.loading = true
      this.$store.dispatch('section/loadItemsAsPage', this.pagination)
        .then((response) => {
          console.log('reload:', response )
          this.pagination.totalItems = response.data.totalItems
          this.items = response.data.items
          this.loading = false
        }).catch((error) => {
          this.loading = false
          swal('Error!', error.message, 'error')
        })
    },
    reset () {
      this.selectedItem = {
        activeCourse: { id: this.activeCourseId },
        room: {}
      }
    }
  },
  watch: {
    'pagination.rowsPerPage' () {
      this.reload()
    },
    'pagination.q' () {
      this.reload()
    },
    'pagination.page' () {
      this.reload()
    },
    'pagination.descending' () {
      this.reload()
    },
    dialog (val) {
      if(!val) {
        setTimeout(()=>{
          this.reset()
          this.formDialog = null
        }, 300)
        this.reload()
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/management/course/section/index.vue